import React from 'react'
import { Offcanvas } from 'react-bootstrap';
// import { Button } from '../../components'
import "./index.scss"

export const Drawer = ({ children, handleCloseDrawer, data, title }) => {
    const handleClose = () => handleCloseDrawer();

    return (
        <div className='drawer'>
            <Offcanvas
                keyboard={true}
                bsPrefix="offcanvas"
                renderStaticNode={true}
                enforceFocus={true}
                backdrop={true}
                show={data.isOpen}
                onHide={handleClose}
                placement={data.position}
            >
                <Offcanvas.Header>
                    <Offcanvas.Title>{title || ''}</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    {children || ''}
                </Offcanvas.Body>
            </Offcanvas>
        </div>
    )
}
